import { useEffect, useRef, useState } from 'react'
import { superAxiosRequest } from 'axiosApi'
import swal from 'sweetalert'

export default function useFileUpload({
  url = 'ebooks/file_upload',
  name = 'file',
  onUploadEnd = () => {},
  crm = false,
}) {
  const refInput = useRef()
  const [file, setFile] = useState(null)
  const [progress, setProgress] = useState(0)
  const [isUploaded, setIsUploaded] = useState(false)

  useEffect(() => {
    if (file) {
      const formData = new FormData()
      const newFileName = file.name
      const newFile = new File([file], newFileName, { type: file.type })
      formData.append(name, newFile)

      const apiConf = {
        method: 'post',
        link: url,
        ...(crm && { crm: crm }),
      }

      const axiosConfig = {
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.floor(
            (progressEvent.loaded / progressEvent.total) * 100,
          )
          setProgress(percentCompleted)
        },
      }

      superAxiosRequest(apiConf, formData, 'media', axiosConfig)
        .then((res) => {
          onUploadEnd(res.data.file)
          setIsUploaded(true)
        })
        .catch((err) => {
          setFile(null)
          setIsUploaded(false)
          swal('', err.response.data.file[0], 'error')
        })
    } else {
      setIsUploaded(false)
    }
  }, [file])

  return {
    refInput,
    progress,
    file,
    setFile,
    isUploaded,
  }
}
